import React from "react";

const VideoPlaceholder = ({ aspectRatio = 16 / 9, style = {}, className = "", src }) => {
  return (
    <div
      className={className}
      style={{
        width: "100%",
        paddingTop: `${100 / aspectRatio}%`, // 16:9 = 56.25%
        background: src ? `url(${src}) center center / cover` : "#000",
        position: "relative",
        aspectRatio,
        ...style,
      }}
    />
  );
};

export default VideoPlaceholder; 